import React from "react";
import { useNavigate } from "react-router";
import { AdminFormPage } from "@components/CatalogIndex/AdminFormPage";
import NoteForm from "../NoteForm/NoteForm";

const FORM_ID = "note-form";

interface Props {
  projectId: string;
  permission: string;
  projectStatus: string;
}

const New: React.FC<Props> = ({ projectId, permission, projectStatus }) => {
  const navigate = useNavigate();

  const canSave = permission !== "view" && projectStatus === "building";

  return (
    <AdminFormPage
      title="Add Note"
      formId={canSave ? FORM_ID : undefined}
      onCancel={() => navigate(`/projects/${projectId}/notes`, { state: null })}
    >
      <NoteForm formId={FORM_ID} projectId={projectId} />
    </AdminFormPage>
  );
};

export default New;
